export const FIELD_TYPES = { text: "text", textarea: "textarea", select: "select", number: "number", date: "date" };

const f = (key, label, type = "text", options) => ({ key, label, type, options });

export const MODULES = {
  raci: {
    title: "RACI Matrix", overline: "Governance", tool: "RACI",
    columns: ["role", "category", "interest", "influence", "raci", "expectation", "comms"],
    badges: ["interest", "influence", "raci", "category"],
    fields: [f("role", "Role"), f("category", "Category", "select", ["Internal", "External"]),
      f("interest", "Interest", "select", ["H", "M", "L"]), f("influence", "Influence", "select", ["H", "M", "L"]),
      f("raci", "RACI", "select", ["R", "A", "C", "I"]), f("expectation", "Expectation", "textarea"), f("comms", "Comms Cadence")],
  },
  stakeholders: {
    title: "Stakeholder Register", overline: "Governance", tool: "STAKEHOLDER_REGISTER",
    columns: ["name", "roleArea", "interest", "influence", "engagementApproach", "owner"],
    badges: ["interest", "influence"],
    fields: [f("name", "Name"), f("roleArea", "Role / Area"), f("interest", "Interest", "select", ["H", "M", "L"]),
      f("influence", "Influence", "select", ["H", "M", "L"]), f("engagementApproach", "Engagement Approach", "textarea"), f("owner", "Owner")],
  },
  communications_plan: {
    title: "Communications Plan", overline: "Governance", tool: "COMMUNICATIONS_PLAN",
    columns: ["audience", "keyMessage", "channel", "frequency", "owner", "timing", "status"],
    badges: ["status"],
    fields: [f("audience", "Audience"), f("keyMessage", "Key Message", "textarea"), f("channel", "Channel"),
      f("frequency", "Frequency"), f("owner", "Owner"), f("timing", "Timing"),
      f("status", "Status", "select", ["Planned", "Active", "Complete"])],
  },
  meetings: {
    title: "Meetings — Agenda & Minutes", overline: "Delivery", tool: "MEETING_AGENDA_MINUTES",
    columns: ["purpose", "dateTime", "location", "chair"],
    badges: [],
    fields: [f("purpose", "Purpose"), f("dateTime", "Date / Time", "date"), f("location", "Location"),
      f("chair", "Chair"), f("notes", "Notes / Minutes", "textarea")],
  },
  action_decision_log: {
    title: "Action & Decision Log", overline: "Delivery", tool: "ACTION_DECISION_LOG",
    columns: ["date", "actionOrDecision", "type", "owner", "dueDate", "status"],
    badges: ["type", "status"],
    fields: [f("date", "Date", "date"), f("actionOrDecision", "Action / Decision", "textarea"),
      f("type", "Type", "select", ["A", "D"]), f("owner", "Owner"), f("dueDate", "Due Date", "date"),
      f("status", "Status", "select", ["Open", "InProgress", "Closed"])],
  },
  raid_items: {
    title: "RAID Log", overline: "Risk Management", tool: "RAID",
    columns: ["type", "description", "impact", "priority", "owner", "responseAction", "targetDate", "status"],
    badges: ["type", "priority", "status"],
    fields: [f("type", "Type", "select", ["Risk", "Assumption", "Issue", "Dependency"]),
      f("description", "Description", "textarea"), f("impact", "Impact"), f("priority", "Priority", "select", ["H", "M", "L"]),
      f("owner", "Owner"), f("responseAction", "Response / Action", "textarea"), f("targetDate", "Target Date", "date"),
      f("status", "Status", "select", ["Open", "Mitigating", "Closed"])],
  },
  risk_issue_log: {
    title: "Risk & Issue Log", overline: "Risk Management", tool: "RISK_ISSUE_LOG",
    columns: ["description", "type", "impact", "likelihood", "owner", "mitigation", "status"],
    badges: ["type", "impact", "likelihood", "status"],
    fields: [f("description", "Description", "textarea"), f("type", "Type", "select", ["Risk", "Issue"]),
      f("impact", "Impact", "select", ["High", "Medium", "Low"]), f("likelihood", "Likelihood", "select", ["High", "Medium", "Low"]),
      f("impactScore", "Impact score (1–5)", "select", ["1", "2", "3", "4", "5"]),
      f("likelihoodScore", "Likelihood score (1–5)", "select", ["1", "2", "3", "4", "5"]),
      f("owner", "Owner"), f("mitigation", "Mitigation", "textarea"),
      f("status", "Status", "select", ["Open", "Mitigating", "Closed"])],
  },
  requirements: {
    title: "Requirements Traceability Matrix", overline: "Scope · Agreement → Build → PVT → UAT → Sign-off", tool: "RTM",
    columns: ["reqId", "description", "priority", "agreedDate", "configBuildRef", "pvt", "uat", "clientSignoffDate", "status"],
    badges: ["priority", "status", "pvt", "uat"],
    fields: [f("reqId", "Req ID"), f("description", "Requirement Description", "textarea"),
      f("priority", "Priority (H/M/L)", "select", ["H", "M", "L"]),
      f("agreedDate", "Requirements Agreed (Date)", "date"),
      f("configBuildRef", "Config / Build Ref"),
      f("pvt", "PVT (P/F)", "select", ["P", "F"]),
      f("uat", "UAT (P/F)", "select", ["P", "F"]),
      f("clientSignoffDate", "Client Sign-off (Date)", "date"),
      f("status", "Status", "select", ["ToBeAgreed", "Agreed", "InBuild", "PVT", "UAT", "SignedOff"])],
  },
  acceptance_criteria: {
    title: "Acceptance Criteria", overline: "Scope", tool: "ACCEPTANCE_CRITERIA",
    columns: ["ref", "criterion", "met", "evidence"],
    badges: ["met"],
    fields: [f("ref", "Ref"), f("criterion", "Criterion", "textarea"),
      f("met", "Met?", "select", ["Y", "N"]), f("evidence", "Evidence", "textarea")],
  },
  training_plan: {
    title: "Training Plan", overline: "Transition", tool: "TRAINING_PLAN",
    columns: ["audience", "module", "objectives", "format", "duration", "schedule", "trainer"],
    badges: [],
    fields: [f("audience", "Audience"), f("module", "Module"), f("objectives", "Objectives", "textarea"),
      f("format", "Format"), f("duration", "Duration"), f("schedule", "Schedule"), f("trainer", "Trainer")],
  },
  data_migration_plan: {
    title: "Data Migration Plan", overline: "Transition", tool: "DATA_MIGRATION_PLAN",
    columns: ["dataObject", "sourceSystem", "target", "volume", "mapping", "owner", "validation"],
    badges: [],
    fields: [f("dataObject", "Data Object"), f("sourceSystem", "Source System"), f("target", "Target"),
      f("volume", "Volume"), f("mapping", "Mapping / Transform", "textarea"), f("owner", "Owner"),
      f("validation", "Validation", "textarea")],
  },
  go_live_checklist: {
    title: "Go-Live Checklist", overline: "Transition", tool: "GO_LIVE_CHECKLIST",
    columns: ["number", "item", "category", "owner", "due", "complete"],
    badges: ["complete", "category"],
    fields: [f("number", "#", "number"), f("item", "Item", "textarea"), f("category", "Category"),
      f("owner", "Owner"), f("due", "Due", "date"), f("complete", "Complete?", "select", ["Y", "N"])],
  },
  transition_plan: {
    title: "Transition Plan", overline: "Transition", tool: "TRANSITION_PLAN",
    columns: ["area", "description", "outgoingOwner", "receivingOwner", "targetDate", "status"],
    badges: ["status"],
    fields: [f("area", "Area"), f("description", "Description", "textarea"), f("outgoingOwner", "Outgoing Owner"),
      f("receivingOwner", "Receiving Owner"), f("targetDate", "Target Date", "date"),
      f("status", "Status", "select", ["Planned", "InProgress", "Complete"])],
  },
  backlog_items: {
    title: "User Story Backlog", overline: "Agile Toolkit", tool: "USER_STORY_BACKLOG",
    columns: ["rank", "title", "type", "storyPoints", "acceptanceCriteria", "status"],
    badges: ["type", "status"],
    fields: [f("rank", "Rank", "number"), f("title", "Story Title", "textarea"), f("description", "Description", "textarea"),
      f("acceptanceCriteria", "Acceptance Criteria", "textarea"), f("storyPoints", "Story Points", "number"),
      f("type", "Type", "select", ["Story", "Epic", "Spike", "Bug"]),
      f("status", "Status", "select", ["Backlog", "InProgress", "Done"])],
  },
  change_champions: {
    title: "Change Champions Network", overline: "Change Management", tool: "CHANGE_MANAGEMENT",
    columns: ["roleInNetwork", "siteOrArea", "isActive"],
    badges: [],
    fields: [f("roleInNetwork", "Role in Network"), f("siteOrArea", "Site / Area"),
      f("isActive", "Active", "select", ["true", "false"])],
  },
  defect_log: {
    title: "Defect Log", overline: "Quality", tool: "DEFECT_LOG",
    columns: ["ref", "description", "severity", "owner", "raisedDate", "status"],
    badges: ["severity", "status"],
    fields: [f("ref", "Ref"), f("description", "Description", "textarea"),
      f("severity", "Severity", "select", ["Critical", "High", "Medium", "Low"]), f("owner", "Owner"),
      f("raisedDate", "Raised", "date"), f("status", "Status", "select", ["Open", "InProgress", "Fixed", "Closed"])],
  },
  finance_lines: {
    title: "Finance — Budget / Actual / Forecast", overline: "Value", tool: null,
    columns: ["category", "description", "budget", "actual", "forecast", "owner"],
    badges: [],
    fields: [f("category", "Category"), f("description", "Description", "textarea"), f("budget", "Budget ($)", "number"),
      f("actual", "Actual ($)", "number"), f("forecast", "Forecast ($)", "number"), f("owner", "Owner")],
  },
  scorecard_metrics: {
    title: "Balanced Scorecard", overline: "Value", tool: null,
    columns: ["perspective", "name", "target", "actual", "unit", "rag", "owner"],
    badges: ["rag", "perspective"],
    fields: [f("perspective", "Perspective", "select", ["Financial", "Customer", "Internal Process", "Learning & Growth"]),
      f("name", "Metric"), f("target", "Target"), f("actual", "Actual"), f("unit", "Unit"),
      f("rag", "RAG", "select", ["Green", "Amber", "Red"]), f("owner", "Owner")],
  },
  benefits: {
    title: "Benefits Register", overline: "Benefits Realisation", tool: null,
    columns: ["title", "category", "baselineValue", "targetValue", "currentValue", "unit", "expectedRealisationDate", "status"],
    badges: ["category", "status"],
    fields: [f("title", "Benefit"), f("category", "Category", "select", ["Financial", "Customer", "Operational", "Strategic", "Compliance", "Other"]),
      f("measurementMethod", "Measurement Method", "textarea"), f("unit", "Unit"), f("baselineValue", "Baseline", "number"),
      f("targetValue", "Target", "number"), f("currentValue", "Current Value", "number"),
      f("expectedRealisationDate", "Expected Realisation", "date"),
      f("status", "Status", "select", ["Identified", "BaselineSet", "Tracking", "Realised", "PartiallyRealised", "NotRealised", "Deferred"]),
      f("owner", "Owner")],
  },
  pirs: {
    title: "Post-Implementation Review", overline: "Benefits Realisation", tool: null,
    columns: ["reviewDate", "facilitator", "overallOutcome", "summary", "recommendations"],
    badges: ["overallOutcome"],
    fields: [f("reviewDate", "Review Date", "date"), f("facilitator", "Facilitator"), f("attendees", "Attendees", "textarea"),
      f("overallOutcome", "Overall Outcome", "select", ["Successful", "PartiallySuccessful", "Unsuccessful", "TooEarlyToTell"]),
      f("summary", "Summary", "textarea"), f("whatWentWell", "What Went Well", "textarea"),
      f("whatCouldImprove", "What Could Improve", "textarea"), f("recommendations", "Recommendations", "textarea"),
      f("benefitsRealisationSummary", "Benefits Realisation Summary", "textarea")],
  },
  lessons_learned: {
    title: "Lessons Learned", overline: "Benefits Realisation", tool: null,
    columns: ["category", "description", "impact", "recommendation"],
    badges: ["category"],
    fields: [f("category", "Category"), f("description", "Description", "textarea"),
      f("impact", "Impact", "textarea"), f("recommendation", "Recommendation", "textarea")],
  },
  a3_items: {
    title: "A3 Problem Solving", overline: "Lean Toolkit", tool: null,
    columns: ["title", "rootCause", "countermeasures", "owner", "status"],
    badges: ["status"],
    fields: [f("title", "Problem Title"), f("background", "Background", "textarea"),
      f("currentCondition", "Current Condition", "textarea"), f("targetCondition", "Target Condition", "textarea"),
      f("rootCause", "Root Cause Analysis", "textarea"), f("countermeasures", "Countermeasures", "textarea"),
      f("followUp", "Follow-up", "textarea"), f("owner", "Owner"),
      f("status", "Status", "select", ["Open", "InProgress", "Complete"])],
  },
  vsm_steps: {
    title: "Value Stream Map", overline: "Lean Toolkit", tool: null,
    columns: ["stepOrder", "stepName", "processTimeMins", "waitTimeMins", "valueAdded", "owner"],
    badges: ["valueAdded"],
    fields: [f("stepOrder", "Step #", "number"), f("stepName", "Step"), f("processTimeMins", "Process Time (min)", "number"),
      f("waitTimeMins", "Wait Time (min)", "number"), f("valueAdded", "Value Added?", "select", ["Y", "N"]), f("owner", "Owner")],
  },
  kaizen_actions: {
    title: "Kaizen Actions", overline: "Lean Toolkit", tool: null,
    columns: ["title", "area", "impact", "effort", "owner", "dueDate", "status"],
    badges: ["impact", "effort", "status"],
    fields: [f("title", "Improvement"), f("area", "Area"), f("description", "Description", "textarea"),
      f("impact", "Impact", "select", ["High", "Medium", "Low"]), f("effort", "Effort", "select", ["High", "Medium", "Low"]),
      f("owner", "Owner"), f("dueDate", "Due", "date"), f("status", "Status", "select", ["Open", "InProgress", "Done"])],
  },
  sipoc_rows: {
    title: "SIPOC Diagram", overline: "Six Sigma Toolkit · Suppliers → Inputs → Process → Outputs → Customers", tool: null,
    columns: ["stepOrder", "suppliers", "inputs", "processStep", "outputs", "customers"],
    badges: [],
    fields: [f("stepOrder", "Step #", "number"), f("processStep", "Process Step (high level)"),
      f("suppliers", "Suppliers", "textarea"), f("inputs", "Inputs", "textarea"),
      f("outputs", "Outputs", "textarea"), f("customers", "Customers", "textarea")],
  },
  benefit_plan_rows: {
    title: "Benefits Realisation Plan", overline: "Value · Who measures what, when and how", tool: null,
    columns: ["benefit", "measure", "method", "frequency", "owner", "firstMeasureDate", "status"],
    badges: ["status"],
    fields: [f("benefit", "Benefit"), f("measure", "Measure / KPI"),
      f("method", "How it's measured", "textarea"), f("frequency", "Frequency", "select", ["Weekly", "Monthly", "Quarterly", "At Go-Live", "Post Go-Live", "Annually"]),
      f("owner", "Who measures (owner)"), f("firstMeasureDate", "First measurement", "date"),
      f("baselineDate", "Baseline captured", "date"),
      f("status", "Status", "select", ["Planned", "BaselineSet", "Measuring", "Complete"])],
  },
  control_plan_rows: {
    title: "Control Plan", overline: "Six Sigma Toolkit · Sustain the improvement", tool: null,
    columns: ["processStep", "characteristic", "specification", "measurementMethod", "sampleSizeFreq", "controlMethod", "reactionPlan", "owner"],
    badges: [],
    fields: [f("processStep", "Process Step"), f("characteristic", "Characteristic (CTQ)"),
      f("specification", "Specification / Limit"), f("measurementMethod", "Measurement Method"),
      f("sampleSizeFreq", "Sample Size / Frequency"), f("controlMethod", "Control Method"),
      f("reactionPlan", "Reaction Plan", "textarea"), f("owner", "Owner")],
  },
  voc_ctq_rows: {
    title: "VOC / CTQ Tree", overline: "Six Sigma Toolkit · Voice of Customer → Critical to Quality", tool: null,
    columns: ["vocStatement", "keyDriver", "ctq", "metric", "target", "priority"],
    badges: ["priority"],
    fields: [f("vocStatement", "Voice of Customer (verbatim)", "textarea"), f("keyDriver", "Key Driver / Need"),
      f("ctq", "CTQ Requirement", "textarea"), f("metric", "Metric"), f("target", "Target / Spec"),
      f("priority", "Priority", "select", ["H", "M", "L"])],
  },
};

export const NAV_SECTIONS = [
  {
    label: "Overview",
    items: [
      { path: "dashboard", label: "Dashboard", tool: null },
      { path: "charter", label: "Project Charter", tool: "CHARTER" },
      { path: "status-reports", label: "Status Reports", tool: "STATUS_REPORT" },
      { path: "team-status", label: "Team Status Updates", tool: null },
    ],
  },
  {
    label: "Plan",
    items: [
      { path: "members", label: "Members & Roles", tool: null },
      { path: "workload", label: "Resource Workload", tool: null },
      { path: "raci", label: "RACI Matrix", tool: "RACI" },
      { path: "stakeholders", label: "Stakeholders", tool: "STAKEHOLDER_REGISTER" },
      { path: "schedule", label: "WBS / Gantt / CPM", tool: "PROJECT_PLAN_MILESTONES" },
      { path: "dependency-map", label: "Dependency Map", tool: "PROJECT_PLAN_MILESTONES" },
      { path: "scenarios", label: "What-if Scenarios", tool: "PROJECT_PLAN_MILESTONES" },
      { path: "kanban", label: "Kanban Board", tool: null },
      { path: "capacity-plan", label: "Capacity & Demand", tool: null },
      { path: "timesheet", label: "My Timesheet", tool: null },
      { path: "communications_plan", label: "Communications Plan", tool: "COMMUNICATIONS_PLAN" },
    ],
  },
  {
    label: "Scope & Quality",
    items: [
      { path: "requirements", label: "Requirements (RTM)", tool: "RTM" },
      { path: "signoff", label: "Requirements Sign-off", tool: "REQUIREMENTS_SIGNOFF" },
      { path: "acceptance_criteria", label: "Acceptance Criteria", tool: "ACCEPTANCE_CRITERIA" },
      { path: "defect_log", label: "Defect Log", tool: "DEFECT_LOG" },
    ],
  },
  {
    label: "Deliver",
    items: [
      { path: "raid_items", label: "RAID Log", tool: "RAID" },
      { path: "risk_issue_log", label: "Risk & Issue Log", tool: "RISK_ISSUE_LOG" },
      { path: "action_decision_log", label: "Actions & Decisions", tool: "ACTION_DECISION_LOG" },
      { path: "meetings", label: "Meetings", tool: "MEETING_AGENDA_MINUTES" },
    ],
  },
  {
    label: "Change",
    items: [
      { path: "changes", label: "Change Requests", tool: "CHANGE_MANAGEMENT" },
      { path: "change_champions", label: "Change Champions", tool: "CHANGE_MANAGEMENT" },
    ],
  },
  {
    label: "Value",
    items: [
      { path: "finance_lines", label: "Finance", tool: null },
      { path: "scorecard_metrics", label: "Balanced Scorecard", tool: null },
      { path: "benefit_plan_rows", label: "Benefits Plan", tool: null },
      { path: "benefits", label: "Benefits Register", tool: null },
      { path: "pirs", label: "PIR", tool: null },
      { path: "lessons_learned", label: "Lessons Learned", tool: null },
    ],
  },
  {
    label: "Transition",
    items: [
      { path: "training_plan", label: "Training Plan", tool: "TRAINING_PLAN" },
      { path: "data_migration_plan", label: "Data Migration", tool: "DATA_MIGRATION_PLAN" },
      { path: "go_live_checklist", label: "Go-Live Checklist", tool: "GO_LIVE_CHECKLIST" },
      { path: "transition_plan", label: "Transition Plan", tool: "TRANSITION_PLAN" },
      { path: "closeout", label: "Closeout Report", tool: "CLOSEOUT_REPORT" },
    ],
  },
  {
    label: "Method Toolkits",
    collapsible: true,
    subs: [
      {
        label: "Lean",
        items: [
          { path: "a3_items", label: "A3 Problem Solving", tool: null },
          { path: "vsm_steps", label: "Value Stream Map", tool: null },
          { path: "kaizen_actions", label: "Kaizen Actions", tool: null },
          { path: "huddle", label: "Huddle Board", tool: null },
        ],
      },
      {
        label: "Six Sigma",
        items: [
          { path: "fmea", label: "FMEA", tool: "FMEA" },
          { path: "gauge-rr", label: "Gauge R&R", tool: null },
          { path: "capability", label: "Process Capability", tool: null },
          { path: "process-map", label: "Process Map", tool: null },
          { path: "sipoc_rows", label: "SIPOC", tool: null },
          { path: "control_plan_rows", label: "Control Plan", tool: null },
          { path: "voc_ctq_rows", label: "VOC / CTQ", tool: null },
        ],
      },
      {
        label: "Agile",
        items: [
          { path: "backlog_items", label: "Backlog", tool: "USER_STORY_BACKLOG" },
        ],
      },
    ],
  },
  {
    label: "Settings",
    items: [
      { path: "workflows-page", label: "Workflows", tool: null },
      { path: "tools", label: "Toolkit Manager", tool: null },
    ],
  },
];
